import startCase from 'lodash/startCase';

import { ContentType } from '../types';

import type { ClientRoute } from '../../static-context';

export interface BreedRouteData {
  name: string;
  slug: string;
  url: string;
}

export function getBreedRoutesFromRoutes(
  routes: ClientRoute[]
): BreedRouteData[] {
  return routes
    .filter(route => route.document?.type === ContentType.breed)
    .map(route => {
      const slug =
        route.document?.uid ?? route.url.split('/breed/')[1] ?? route.url;
      return {
        name: route.title || startCase(slug),
        slug,
        url: route.url,
      };
    });
}
